import axios from 'axios';
import { ClientGroupDetail, ClientGroupManageRequest } from '../types/adminClientGroup';

const API_BASE_URL = process.env.REACT_APP_API_URL || window.location.origin;
const GROUPS_URL = `${API_BASE_URL}/api/admin/client-groups`;

const authHeaders = (adminApiKey: string) => ({
  headers: {
    'X-Admin-API-Key': adminApiKey,
    'Content-Type': 'application/json',
  },
});

const extractError = (error: any, fallback: string): Error => {
  if (error.response?.status === 401) {
    return new Error('Invalid admin API key');
  }
  const data = error.response?.data;
  if (data) {
    if (typeof data === 'string') return new Error(data);
    if (data.error) return new Error(data.error);
    if (data.message) return new Error(data.message);
  }
  return new Error(fallback);
};

export const listClientGroups = async (adminApiKey: string): Promise<ClientGroupDetail[]> => {
  try {
    const response = await axios.get(GROUPS_URL, authHeaders(adminApiKey));
    return response.data;
  } catch (error: any) {
    throw extractError(error, 'Failed to load client groups');
  }
};

export const createClientGroup = async (
  payload: ClientGroupManageRequest,
  adminApiKey: string
): Promise<ClientGroupDetail> => {
  try {
    const response = await axios.post(GROUPS_URL, payload, authHeaders(adminApiKey));
    return response.data;
  } catch (error: any) {
    throw extractError(error, 'Failed to create client group');
  }
};

export const updateClientGroup = async (
  id: number,
  payload: ClientGroupManageRequest,
  adminApiKey: string
): Promise<ClientGroupDetail> => {
  try {
    const response = await axios.put(`${GROUPS_URL}/${id}`, payload, authHeaders(adminApiKey));
    return response.data;
  } catch (error: any) {
    throw extractError(error, 'Failed to update client group');
  }
};

export const deleteClientGroup = async (id: number, adminApiKey: string): Promise<void> => {
  try {
    await axios.delete(`${GROUPS_URL}/${id}`, authHeaders(adminApiKey));
  } catch (error: any) {
    throw extractError(error, 'Failed to delete client group');
  }
};
